/**
 * Globally-mounted Database Blueprint setup dialog. Any surface that wants to open
 * the wizard calls `useDatabaseBlueprintSetupStore.getState().openSetupDialog(...)`.
 *
 * Mounted once at the App root (see `src/App.tsx`).
 */

import { DatabaseBlueprintSetupDialog } from './DatabaseBlueprintSetupDialog';

export function GlobalDatabaseBlueprintSetupDialog() {
  return <DatabaseBlueprintSetupDialog />;
}
